module.exports = __webpack_public_path__ + "img/boiler-third.5bff4b14.webp";